export default () => ({
    type: "CLEAR_LICENCE_IMAGES"
});